<template>
  <div class="mall-panel">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'MallPanel'
};
</script>

<style lang="scss">
.mall-panel {
  background: #fff;
  border-radius: 4px;

  + .mall-panel {
    margin-top: 8px;
  }
}
</style>
